import {useEffect, useEffectEvent, useState} from 'react';
import {QueryStatus} from '@reduxjs/toolkit/query/react';
import type {HttpError} from 'api/http/types';
import type {DataLoadStatus} from 'api/types';
import type {WorkMetadata} from '../types';
import {useLazyGetWorkQuery} from '../workApi';

export const useWorkMetadata = (
  workId: string | undefined,
): DataLoadStatus<WorkMetadata> => {
  const [getWork, {status}] = useLazyGetWorkQuery();

  const [result, setResult] = useState<DataLoadStatus<WorkMetadata>>({
    status: 'NotLoaded',
  });

  const setResultEffect = useEffectEvent(setResult);

  useEffect(() => {
    if (workId && status === QueryStatus.uninitialized) {
      setResultEffect(old => ({status: 'Loading', data: old.data}));
      getWork({id: workId})
        .unwrap()
        .then(data => setResultEffect(() => ({status: 'Loaded', data})))
        .catch((error: HttpError) =>
          setResultEffect(() => ({status: 'Failed', error})),
        );
    }
    // Only trigger if workId changes
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [workId]);

  return result;
};
